import { S as Swiper, E as EffectFade } from "@theme/effect-fade";
import { P as Pagination } from "@theme/pagination";
import { g as gsapWithCSS } from "@theme/theme";
class ProductSliderComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      slider: this.querySelector(".swiper"),
      titles: this.querySelectorAll(".js-slide-title"),
      texts: this.querySelectorAll(".js-slide-text"),
      images: this.querySelectorAll(".js-slide-image"),
      navBtn: this.querySelector(".js-slider-nav"),
      navBtnMobile: this.querySelector(".js-slider-nav-mobile"),
      pagination: this.querySelector(".swiper-pagination"),
      firstTitle: this.querySelector(".js-slide-title")
    };
    this.mm = gsapWithCSS.matchMedia();
  }
  connectedCallback() {
    this.setTitleOffset();
    this.initSlider();
    window.addEventListener("resize", () => {
      setTimeout(() => this.setTitleOffset(), 200);
    });
  }
  setTitleOffset() {
    const offset = this.DOM.firstTitle.offsetTop - this.DOM.slider.offsetTop;
    this.style.setProperty("--title-offset-top", `${offset}px`);
  }
  initSlider() {
    if (this.DOM.slider.querySelectorAll(".swiper-slide").length <= 1) {
      this.classList.add("-no-slider");
      return;
    }
    this.mm.add("(min-width: 1367px)", () => {
      gsapWithCSS.set(this.DOM.titles, { autoAlpha: 0, y: 50 });
      gsapWithCSS.set(this.DOM.texts, { autoAlpha: 0, y: 50 });
      gsapWithCSS.set(this.DOM.images, { autoAlpha: 0, y: 50 });
      gsapWithCSS.set(this.DOM.titles[0], { autoAlpha: 1, y: 0 });
      gsapWithCSS.set(this.DOM.texts[0], { autoAlpha: 1, y: 0 });
      gsapWithCSS.set(this.DOM.images[0], { autoAlpha: 1, y: 0 });
      gsapWithCSS.set(this.DOM.navBtn, { autoAlpha: 0 });
      this.swiper = new Swiper(this.DOM.slider, {
        loop: true,
        slidesPerView: 1,
        speed: 1e3,
        effect: "fade",
        fadeEffect: {
          crossFade: false
        },
        modules: [EffectFade],
        on: {
          slideChangeTransitionStart: (swiper) => {
            this.animateOut(swiper.slides[swiper.previousIndex]);
            this.animateIn(swiper.slides[swiper.activeIndex]);
          }
        }
      });
      const onMouseEnter = () => {
        gsapWithCSS.to(this.DOM.navBtn, { autoAlpha: 1, duration: 0.5 });
      };
      const onMouseLeave = () => {
        gsapWithCSS.to(this.DOM.navBtn, { autoAlpha: 0, duration: 0.5 });
      };
      const xTo = gsapWithCSS.quickTo(this.DOM.navBtn, "x", { duration: 0.6, ease: "power3" });
      const yTo = gsapWithCSS.quickTo(this.DOM.navBtn, "y", { duration: 0.6, ease: "power3" });
      const onMouseMove = (e) => {
        xTo(e.clientX);
        yTo(e.clientY);
        gsapWithCSS.to(this.DOM.navBtn, { rotation: e.clientX < window.innerWidth / 2 ? 180 : 0, duration: 0.5 });
      };
      const onLinkEnter = () => {
        gsapWithCSS.to(this.DOM.navBtn, { autoAlpha: 0, duration: 0.5 });
      };
      const onLinkLeave = () => {
        gsapWithCSS.to(this.DOM.navBtn, { autoAlpha: 1, duration: 0.5 });
      };
      const onClick = (e) => {
        if (e.target.closest("a")) return;
        e.clientX < window.innerWidth / 2 ? this.swiper.slidePrev() : this.swiper.slideNext();
      };
      this.addEventListener("mouseenter", onMouseEnter);
      this.addEventListener("mouseleave", onMouseLeave);
      document.addEventListener("mousemove", onMouseMove);
      this.addEventListener("click", onClick);
      this.querySelectorAll("a").forEach((link) => {
        link.addEventListener("mouseenter", onLinkEnter);
        link.addEventListener("mouseleave", onLinkLeave);
      });
      return () => {
        gsapWithCSS.set(this.DOM.navBtn, { autoAlpha: 1 });
        console.log("clean");
        gsapWithCSS.set(this.DOM.titles, { clearProps: "all" });
        gsapWithCSS.set(this.DOM.texts, { clearProps: "all" });
        gsapWithCSS.set(this.DOM.images, { clearProps: "all" });
        this.removeEventListener("mouseenter", onMouseEnter);
        this.removeEventListener("mouseleave", onMouseLeave);
        document.removeEventListener("mousemove", onMouseMove);
        this.removeEventListener("click", onClick);
        this.querySelectorAll("a").forEach((link) => {
          link.removeEventListener("mouseenter", onLinkEnter);
          link.removeEventListener("mouseleave", onLinkLeave);
        });
        this.swiper.destroy();
      };
    });
    this.mm.add("(max-width: 1366px)", () => {
      gsapWithCSS.set(this.DOM.navBtnMobile, { autoAlpha: 1 });
      this.swiper = new Swiper(this.DOM.slider, {
        loop: true,
        slidesPerView: 1,
        speed: 1e3,
        effect: "fade",
        fadeEffect: {
          crossFade: false
        },
        modules: [EffectFade, Pagination],
        pagination: {
          el: this.DOM.pagination,
          clickable: true
        }
      });
      this.DOM.navBtnMobile.addEventListener("click", () => {
        this.swiper.slideNext();
      });
      return () => {
        this.swiper.destroy();
      };
    });
  }
  animateOut(slide) {
    const title = slide.querySelector(".js-slide-title");
    const text = slide.querySelector(".js-slide-text");
    const image = slide.querySelector(".js-slide-image");
    gsapWithCSS.to([title, text, image], { autoAlpha: 0, y: -50, duration: 0.6, stagger: 0.1 });
  }
  animateIn(slide) {
    const title = slide.querySelector(".js-slide-title");
    const text = slide.querySelector(".js-slide-text");
    const image = slide.querySelector(".js-slide-image");
    gsapWithCSS.set([title, text, image], { autoAlpha: 0, y: 50 });
    gsapWithCSS.to([title, text, image], { autoAlpha: 1, y: 0, duration: 1, stagger: 0.25 });
  }
}
window.customElements.define("c-product-slider", ProductSliderComponent);
